import { isMockMode, postBlast, simulateDelay } from "../../api";

export interface UpdateBlastRequest {
	blastId: string;
	name: string;
	isDeleted?: boolean;
}

export const updateBlast = (req: UpdateBlastRequest) => {
	if (isMockMode()) return simulateDelay(50, { success: true });

	if (req.isDeleted === undefined) req.isDeleted = false;
	return postBlast(`blasts/update`, req, {
		successMessage: "Blast successfully updated",
	});
};
